import { useMemo, useState, useEffect } from 'react';

export const VendorPhoto = ({ photoUrl, photoReference, alt, vendorName }) => {
  const fallbackProxyUrl = useMemo(() => {
    if (!photoReference) return null;
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:8001';
    return `${apiBase}/api/places/photos/photo?photo_reference=${encodeURIComponent(photoReference)}&maxwidth=800&maxheight=600`;
  }, [photoReference]);

  // Prefer stored URL; fallback to backend proxy if we only have photo_reference
  const resolvedUrl = photoUrl || fallbackProxyUrl;

  const [currentPhotoUrl, setCurrentPhotoUrl] = useState(resolvedUrl);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setCurrentPhotoUrl(resolvedUrl);
    setHasError(false);
  }, [resolvedUrl, vendorName]);

  const handleImageError = (event) => {
    console.log('VendorPhoto: Image error detected', {
      photoUrl: currentPhotoUrl,
      photoReference,
      errorEvent: event,
    });
    setHasError(true);
  };

  if (hasError || !currentPhotoUrl) {
    return null; // Don't render anything if we can't load the image
  }

  return (
    <div className="shrink-0">
      <img 
        key={currentPhotoUrl} // Force re-render when URL changes
        src={currentPhotoUrl} 
        alt={alt}
        className="w-24 h-24 sm:w-32 sm:h-32 object-cover rounded-lg"
        onError={handleImageError}
        onLoad={() => {
          // Reset error state on successful load
          if (hasError) {
            setHasError(false);
          }
        }}
        style={{ display: hasError && !currentPhotoUrl ? 'none' : 'block' }}
      />
    </div>
  );
};

